import { Component } from '@angular/core';
import { TimelineMax, Power2, Quad } from 'gsap';
import * as CustomWiggle from '../../../assets/gsap/plugins/CustomWiggle';
import * as CustomBounce from '../../../assets/gsap/plugins/CustomBounce';
// import { CbsBasicsComponent } from '../animation-base-classes/cbs-basics.component';
import { BasicChartComponent } from '../animation-base-classes/basic-chart.component';
import { IconService } from '../../core/icon.service';
import { params as paramsSocial } from './social.params';
import * as _ from 'lodash';
import * as d3 from 'd3';

@Component({
  selector: 'app-demo-tilastokeskus-triptych-line-hor-steps',
  templateUrl: './demo-tilastokeskus-triptych-line-hor-steps.component.html',
  styleUrls: ['./demo-tilastokeskus-triptych-line-hor-steps.component.scss']
})
export class DemoTilastokeskusTriptychLineHorStepsComponent extends BasicChartComponent {

  private backgroundGroup;
  private slide01Group;
  private slide02Group;
  private slide03Group;

  constructor(
    public iconService: IconService,
  ) {
    super(iconService);
    this.paramObject = {
      'social': paramsSocial,
    };
  }

  public async calculateValues() {
    super.calculateValues();
    this.createLineScales(this.data, this.values);
    this.values['colorScheme'] = { 'value': { 1: this.values['titleTextSlide1FontColor'] } }
  }

  public async createElements() {

    this.slide01Group = this.host.select('#slide-01');
    this.slide01Group.selectAll('*').remove();
    this.drawBackgroundSlide1(this.slide01Group, this.values);
    this.drawArrow(this.slide01Group, this.values);
    let logoGroup = this.drawLogoBackground(this.slide01Group, this.values, false);
    this.drawTilastokeskusLogo(logoGroup, this.values, 'slide1');
    this.drawTitleTextSlide1(this.slide01Group, this.values);
    this.drawTextSlide1(this.slide01Group, this.values);

    this.slide02Group = this.host.select('#slide-02');
    this.slide02Group.selectAll('*').remove();
    this.drawBackgroundSlide2(this.slide02Group, this.values);
    this.drawTitleSlide2(this.slide02Group, this.values);
    this.drawSubTitleSlide2(this.slide02Group, this.values);
    this.drawLogoBackground(this.slide02Group, this.values, true);
    this.drawTilastokeskusLogo(this.slide02Group, this.values, 'slide2');
    this.drawLineHorSteps(this.slide02Group, this.values, this.data);

    this.slide03Group = this.host.select('#slide-03');
    this.slide03Group.selectAll('*').remove();
    this.drawBackgroundSlide3(this.slide03Group, this.values);
    this.drawTilastokeskusLogo(this.slide03Group, this.values, null, 460, 220, 60, null); // NB these need to be moved to params!
    this.drawTilastokeskusText(this.slide03Group, this.values);
    this.drawTilastokeskusWWW(this.slide03Group, this.values);
  }

  public async createAnimation(noAnimation: boolean = false) {
    let p = k => this.parameters[k];
    let v = k => this.values[k];

    let main = new TimelineMax({ repeat: -1 });
    if (!noAnimation) {
      // Slide 01
      let slide01AnimationTotal = new TimelineMax();
      let slide01AppearAnimation = new TimelineMax();
      this.animateSlide1(slide01AppearAnimation);
      slide01AppearAnimation.duration(2);
      slide01AnimationTotal.add(slide01AppearAnimation);
      let pauseSlide01 = new TimelineMax()
        .set({}, {}, 4);
      slide01AnimationTotal.add(pauseSlide01);
      let slide01SlideOutAnimation = new TimelineMax();
      slide01SlideOutAnimation.to(this.slide01Group.node(), 1, { x: -this.values['width'] });
      slide01AnimationTotal.add(slide01SlideOutAnimation);
      main.add(slide01AnimationTotal);
      // Slide 02
      let slide02AnimationTotal = new TimelineMax();
      let linesAnimation = new TimelineMax();
      this.animateNLines(linesAnimation, this.values, this.data);
      linesAnimation.duration(2);
      slide02AnimationTotal.add(linesAnimation);
      let pauseSlide02 = new TimelineMax()
        .set({}, {}, 4);
      slide02AnimationTotal.add(pauseSlide02);
      let slide02SlideOutAnimation = new TimelineMax();
      slide02SlideOutAnimation.to(this.slide02Group.node(), 1, { x: -this.values['width'] });
      slide02AnimationTotal.add(slide02SlideOutAnimation);
      main.add(slide02AnimationTotal);
      // Slide 03
      let slide03AnimationTotal = new TimelineMax();
      let logoAnimation = new TimelineMax();
      this.animateTilastokeskusScaleBarsWithSomeDelay(logoAnimation);
      logoAnimation.duration(1);
      slide03AnimationTotal.add(logoAnimation);
      let pauseSlide03 = new TimelineMax()
        .set({}, {}, 4);
      slide03AnimationTotal.add(pauseSlide03);
      // let slide03SlideOutAnimation = new TimelineMax();
      // slide03SlideOutAnimation.to(this.slide03Group.node(), 1, { x: -this.values['width'] });
      // slide03AnimationTotal.add(slide03SlideOutAnimation);
      main.add(slide03AnimationTotal);
    }

    this.animation = main;
    return this.animation;
  }

  public drawBackgroundSlide1(selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', values['backgroundColor'])
      .attr('stroke', 'none');
  }

  public drawBackgroundSlide2(selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', '#FFFFFF')
      // .attr('fill', '#CACACA')
      .attr('stroke', 'none');
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['bannerHeight'])
      .attr('fill', values['backgroundColor'])
      .attr('stroke', 'none');
  }

  public drawBackgroundSlide3(selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', '#FFFFFF')
      // .attr('fill', '#CACACA')
      .attr('stroke', 'none');
  }

  public drawArrow(selection, values) {
    let group = selection.append('g')
      .attr('transform', `translate(${values['iconX']} ${values['iconY']})`)
      .attr('id', `slide1-icon-${this.id}`);
    group.append('path')
      .attr('fill', values['iconColor'])
      .attr('opacity', values['iconOpacity'])
      .attr('stroke', 'none')
      .attr('d', 'M268.467778,119.653796 L153.560389,6.43501062 C149.20681,2.14480049 143.858499,0 137.500618,0 C131.029601,0 125.731985,2.14480049 121.613952,6.43501062 L6.70656313,119.653796 C2.23490281,124.059135 0,129.336769 0,135.481827 C0,141.510537 2.23737573,146.726039 6.70656313,151.132596 L19.9434937,164.173787 C24.1808447,168.578517 29.4766061,170.786059 35.8301597,170.786059 C42.1843315,170.786059 47.4788565,168.578517 51.7168257,164.173787 L103.610465,113.218176 L103.610465,235.655157 C103.610465,241.679604 105.815693,246.580787 110.22924,250.351396 C114.642786,254.11835 119.967605,256 126.202458,256 L148.795687,256 C155.033013,256 160.355359,254.117741 164.768905,250.351396 C169.182452,246.582005 171.391389,241.679604 171.391389,235.655157 L171.391389,113.218785 L223.284411,164.174396 C227.518052,168.579126 232.813195,170.786668 239.172931,170.786668 C245.40593,170.786668 250.762896,168.579126 255.231465,164.174396 L268.467159,151.133205 C272.821356,146.609693 275,141.394191 275,135.482436 C275.000618,129.453116 272.821974,124.177309 268.467778,119.653796 Z');
  }

  public drawLogoBackground(selection, values, border?: boolean) {
    let group = selection.append('g')
      .attr('id', `slide1-logo-group-${this.id}`);
    group.append('circle')
      .attr('cx', values['logoBackgroundX'])
      .attr('cy', values['logoBackgroundY'])
      .attr('r', values['logoBackgroundRadius'])
      .attr('fill', values['logoBackgroundColor'])
      .attr('stroke', border ? values['logoBorderColor'] : 'none')
      .attr('stroke-width', border ? values['logoBackgroundRadiusWidth'] : null);
    return group;
  }

  public drawTilastokeskusLogo(selection, values, id?: string, x?: number, y?: number, w?: number, h?: number) {
    const logoWidth = 216;
    const logoHeight = 395;
    let factor, actualLogoHeight;
    if (w || values['tilastokeskusLogoWidth']) {
      factor = (w || values['tilastokeskusLogoWidth']) / logoWidth;
      // console.log(`w || values['tilastokeskusLogoWidth']: ${w || values['tilastokeskusLogoWidth']}`);
      // console.log(`Tilastokeskus factor: ${factor}`);
      actualLogoHeight = logoHeight * factor;
      // console.log(`Tilastokeskus logo height: ${logoHeight * factor}`);
    } else if (h || values['tilastokeskusLogoHeight']) {
      factor = (h || values['tilastokeskusLogoHeight']) / logoHeight;
      values['tilastokeskusLogoWidth'] = logoWidth * factor;
      w = logoWidth * factor;
      actualLogoHeight = h || values['tilastokeskusLogoHeight'];
      // console.log(`Tilastokeskus logo width: ${logoWidth * factor}`);
    } else {
      factor = 1;
      actualLogoHeight = logoHeight;
    }
    // console.log(factor);

    let gray = '#bdbcbc';
    let blue = '#0073b0';

    // selection.append('rect').attr('x', 0).attr('y', 0).attr('width', 150).attr('height', 600).attr('fill', 'red');
    // selection.append('rect').attr('x', 450).attr('y', 0).attr('width', 150).attr('height', 600).attr('fill', 'red');
    let idValue = (id ? `${id}-${this.id}` : `${this.id}`);
    // console.log(idValue);
    let outerGroup = selection.append('g')
      .attr('id', `tilastokeskus-logo-outer-group${idValue}`)
      .attr('transform', `translate(${x || values['tilastokeskusLogoX'] - (w || values['tilastokeskusLogoWidth']) / 2} ${(y || values['tilastokeskusLogoY']) - actualLogoHeight / 2})`);
    let innerGroup = outerGroup.append('g')
      .attr('id', `tilastokeskus-logo-inner-group-${idValue}`)
      .attr('transform', `scale(${factor} ${factor}) translate(-20,-12)`);
    // translate(-21.20744,-12.592442)
    let topGroup = innerGroup.append('g')
      .attr('id', `tilastokeskus-logo-top-group-${idValue}`);

    let top01 = topGroup.append('path')
      .attr('id', `tilastokeskus-logo-top01-${idValue}`)
      .attr('class', `tilastokeskus-logo-top-${idValue} tilastokeskus-logo-${idValue}`)
      .attr('fill', blue)
      .attr('d', 'M28.4 219c-2.28-1.14-4.29-3.31-5.75-6.21-2.18-4.32-2.25-5.35-2.23-33.5.02-26.6.184-29.4 1.97-33.3 1.55-3.42 2.91-4.72 6.69-6.39 6.06-2.68 13.8-2.85 17.9-.39 1.71 1.02 3.96 3.25 5 4.96 1.73 2.86 1.91 5.88 2.18 37.2.25 28.6.068 34.3-1.13 35.3-1.44 1.19-15 4.14-19 4.13-1.19 0-3.74-.788-5.66-1.75z');

    let top02 = topGroup.append('path')
      .attr('id', `tilastokeskus-logo-top02-${idValue}`)
      .attr('class', `tilastokeskus-logo-top-${idValue} tilastokeskus-logo-${idValue}`)
      .attr('fill', blue)
      .attr('d', 'M74.6 211c-3.27-1.48-4.74-2.96-6.23-6.23-1.85-4.08-1.95-6.98-1.97-60.1-.021-54.4.03-55.9 2.04-59.8 1.53-3 3.24-4.57 6.64-6.07 3.53-1.56 6.06-1.93 11.1-1.61 5.77.367 6.81.766 9.3 3.55 1.54 1.73 3.28 4.85 3.86 6.94.685 2.47 1.06 24.2 1.06 61.9.005 48.3-.229 58.3-1.38 59.3-.761.632-5.15 1.81-9.75 2.62s-8.82 1.46-9.37 1.45c-.55-.011-2.93-.896-5.28-1.96z');

    let top03 = topGroup.append('path')
      .attr('id', `tilastokeskus-logo-top03-${idValue}`)
      .attr('class', `tilastokeskus-logo-top-${idValue} tilastokeskus-logo-${idValue}`)
      .attr('fill', blue)
      .attr('d', 'M113 204c-.897-1.08-1.1-22.2-.836-87.2.28-69.1.612-86.5 1.7-89.3.743-1.92 2.44-4.97 3.77-6.76s4.25-4.19 6.49-5.34c2.24-1.14 6.47-2.32 9.41-2.63 3.98-.41 5.98-.134 7.83 1.08 1.37.898 2.98 3.32 3.58 5.39.763 2.62 1 28.5.791 85.8-.286 77.8-.398 82.2-2.17 85.5-2.35 4.41-6.38 8.78-9.69 10.5-1.4.734-6.29 2.04-10.9 2.91-4.57.867-8.43 1.58-8.57 1.58-.147 0-.8-.642-1.45-1.43z');

    let top04 = topGroup.append('path')
      .attr('id', `tilastokeskus-logo-top04-${idValue}`)
      .attr('class', `tilastokeskus-logo-top-${idValue} tilastokeskus-logo-${idValue}`)
      .attr('fill', blue)
      .attr('d', 'M160 196c-.367-.367-.667-27.3-.667-59.8 0-50.7.22-59.8 1.54-63.7 1.69-4.96 6.13-10.1 10.8-12.5 1.66-.858 5.79-1.78 9.18-2.05 5.3-.426 6.46-.204 8.24 1.58 1.14 1.14 2.57 3.9 3.17 6.14.745 2.77 1 21.2.803 57.8-.291 53.7-.291 53.7-3.12 59.5-2.12 4.32-3.9 6.38-7.13 8.28-2.37 1.39-7.78 3.19-12 4-4.24.811-8.27 1.47-8.95 1.47-.685 0-1.55-.3-1.91-.667z');

    let top05 = topGroup.append('path')
      .attr('id', `tilastokeskus-logo-top05-${idValue}`)
      .attr('class', `tilastokeskus-logo-top-${idValue} tilastokeskus-logo-${idValue}`)
      .attr('fill', blue)
      .attr('d', 'M204 186c-.885-1.65-1.04-10.5-.596-34.6.593-32.4.593-32.4 3.23-37.8 1.99-4.06 3.76-6.05 7.21-8.06 2.51-1.47 6.43-2.96 8.7-3.31 6.06-.92 10.3.492 12.1 4.07 1.34 2.59 1.52 7.41 1.26 33.7-.273 27.7-.485 31-2.17 34.2-2.42 4.54-5.46 7.84-8.86 9.61-1.5.779-6.22 2.09-10.5 2.9-4.28.819-8.1 1.49-8.49 1.49-.393 0-1.25-1-1.9-2.22z');

    let bottomGroup = innerGroup.append('g')
      .attr('id', `tilastokeskus-logo-bottom-group-${idValue}`);

    let bottom01 = bottomGroup.append('path')
      .attr('id', `tilastokeskus-logo-bottom01-${idValue}`)
      .attr('class', `tilastokeskus-logo-bottom-${idValue} tilastokeskus-logo-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M25 314c-1.51-1.51-2.6-3.75-2.63-5.38-.024-1.54-.012-15.6.026-31.3.068-28.4.074-28.5 2.62-33.8 1.85-3.81 3.71-5.93 6.78-7.73 2.33-1.36 7.77-3.15 12.1-3.98 6.02-1.15 8.2-1.23 9.27-.341 1.16.966 1.35 6.86 1.08 34.7-.32 33.6-.32 33.6-3.27 38.9-3.73 6.74-9.2 10.2-17.5 10.9-5.39.489-6.14.308-8.5-2.05z');

    let bottom02 = bottomGroup.append('path')
      .attr('id', `tilastokeskus-logo-bottom02-${idValue}`)
      .attr('class', `tilastokeskus-logo-bottom-${idValue} tilastokeskus-logo-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M70.1 359c-1.38-1.38-2.79-4.03-3.13-5.88-.338-1.85-.48-28.1-.316-58.4.298-55 .298-55 3.1-59.8 1.54-2.62 4.47-5.86 6.5-7.19 2.26-1.48 7.13-3.05 12.6-4.06 5.29-.98 9.23-1.28 9.77-.737.527.527.791 26.4.633 61.9-.273 61-.273 61-3.28 65.9-2.05 3.31-4.44 5.6-7.5 7.15-2.47 1.26-7.04 2.58-10.2 2.93-5.17.589-5.89.423-8.18-1.87z');

    let bottom03 = bottomGroup.append('path')
      .attr('id', `tilastokeskus-logo-bottom03-${idValue}`)
      .attr('class', `tilastokeskus-logo-bottom-${idValue} tilastokeskus-logo-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M116 404c-3.05-3.05-3.05-3.05-3.3-63.9-.138-33.5-.25-71.2-.25-83.9 0-22.6.045-23.1 2.5-27.9 1.38-2.68 4.11-6.17 6.08-7.76 2.69-2.18 5.9-3.36 13-4.8 7.74-1.56 9.66-1.67 10.7-.601 1.09 1.07 1.2 16.6.596 88.1-.73 86.8-.73 86.8-3.33 91.9-1.84 3.62-3.91 5.91-7.1 7.84-2.76 1.67-6.7 2.98-10.2 3.39-5.41.625-5.85.506-8.75-2.4z');

    let bottom04 = bottomGroup.append('path')
      .attr('id', `tilastokeskus-logo-bottom04-${idValue}`)
      .attr('class', `tilastokeskus-logo-bottom-${idValue} tilastokeskus-logo-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M165 340c-2.38-2.09-3.92-4.59-4.67-7.57-.761-3.02-1.12-23-1.12-62.4 0-45.1.276-58.2 1.25-58.9 1.86-1.49 11.1-3.24 17.2-3.24 3.94 0 6.03.562 8.07 2.17 5.55 4.36 5.51 3.99 5.51 65-.001 51.6-.147 56.6-1.75 59.7-.962 1.91-3.23 4.32-5.04 5.37-1.84 1.06-6.08 2.13-9.58 2.41-5.94.476-6.47.333-9.84-2.62z');

    let bottom05 = bottomGroup.append('path')
      .attr('id', `tilastokeskus-logo-bottom05-${idValue}`)
      .attr('class', `tilastokeskus-logo-bottom-${idValue} tilastokeskus-logo-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M210 279c-5.42-4.27-5.63-5.88-5.61-42.1.008-18.3.349-33.8.757-34.4 1.02-1.6 16.8-4.48 20.1-3.67 1.46.36 3.63 1.28 4.82 2.05 1.19.77 2.99 3.06 4 5.09 1.68 3.39 1.81 6.22 1.51 34.2-.278 26.3-.55 30.9-2 33.4-.923 1.59-2.93 3.83-4.46 4.97-1.99 1.48-4.7 2.18-9.5 2.45-5.8.325-7.11.068-9.59-1.89z');
  }

  public drawTilastokeskusText(selection, values) {
    const logoWidth = 820.64;
    const logoHeight = 103.49;

    let factor;
    if (values['tilastokeskusLogoWidth']) {
      factor = values['tilastokeskusTextWidth'] / logoWidth;
    } else if (values['tilastokeskusTextHeight']) {
      factor = values['tilastokeskusTextHeight'] / logoHeight;
      values['tilastokeskusLogoWidth'] = logoWidth * factor;
    } else {
      factor = 1;
    }

    let outerGroup = selection.append('g')
      .attr('transform', `translate(${values['tilastokeskusTextX'] || 0} ${values['tilastokeskusTextY'] || 0})`);

    let innerGroup = outerGroup.append('g')
      .attr('id', `tilastokeskus-text-inner-group-${this.id}`)
      .attr('transform', `scale(${factor} ${factor})`);

    let d = 'm133 113c-1.89-0.999-4.36-3.09-5.5-4.64-2.02-2.76-2.07-3.86-2.07-49.5 0-46.7 0-46.7 3-46.7s3 0 3.5 45.8 0.5 45.8 3.44 48.4c2.73 2.34 3.47 2.49 10 1.95 3.88-0.319 8.29-0.875 9.81-1.24 2.54-0.605 2.75-0.422 2.75 2.35 0 1.93-0.63 3.27-1.75 3.73-0.962 0.395-5.8 0.923-10.8 1.17-7.38 0.373-9.62 0.128-12.4-1.36zm49.1 0.678c-2.4-0.512-6.37-1.9-8.82-3.08-2.7-1.31-5.5-3.74-7.12-6.19-2.13-3.22-2.75-5.49-3.04-11.2-0.293-5.8 0.0391-7.97 1.73-11.3 1.15-2.26 3.65-5.29 5.56-6.74s5.62-3.33 8.26-4.18c3.27-1.05 10.6-1.7 23.1-2.04l18.3-0.5-0.666-4.63c-0.366-2.54-1.3-6.19-2.08-8.09-0.778-1.9-2.19-4.33-3.13-5.4-0.942-1.06-3.68-2.81-6.08-3.89-3.48-1.55-6.55-1.95-15-1.91-5.85 0.0226-12.8 0.458-15.4 0.968-3.61 0.707-5 0.614-5.83-0.393-0.603-0.726-0.94-2.13-0.75-3.12 0.245-1.27 1.65-2 4.83-2.5 2.47-0.384 9.81-0.752 16.3-0.818 8.83-0.0901 13.3 0.331 17.5 1.66 3.82 1.2 6.97 3.09 9.68 5.82 2.21 2.22 4.63 5.84 5.38 8.04 0.94 2.78 1.5 12.1 1.85 30.7 0.502 26.7 0.502 26.7-2.36 27.8-1.58 0.608-10.7 1.28-20.4 1.48-9.62 0.206-19.5-0.0433-21.9-0.555zm31.7-5.64 6.17-0.645-0.274-16.1-0.274-16.1-14.5-0.279c-7.98-0.154-16.7 0.193-19.4 0.769-2.69 0.577-6.46 1.79-8.37 2.7-1.91 0.908-4.32 3.04-5.36 4.73-1.27 2.08-1.88 4.97-1.88 8.93-0.002 3.62 0.618 6.9 1.63 8.61 0.9 1.52 2.88 3.5 4.39 4.4 1.52 0.896 4.49 2.04 6.61 2.54 2.12 0.498 8.63 0.951 14.5 1.01 5.83 0.0553 13.4-0.19 16.8-0.545zm30.3 5.48c-6.02-0.975-6.29-1.14-6-3.68 0.274-2.37 0.681-2.63 3.81-2.38 1.92 0.15 10.2 0.375 18.5 0.5 13.9 0.21 15.3 0.0565 19.2-2.01 2.3-1.23 4.89-3.24 5.75-4.47 0.861-1.23 1.56-4.05 1.56-6.26-0.002-2.23-0.876-5.46-1.96-7.24-1.08-1.77-3.66-4.08-5.75-5.15-2.09-1.06-8.51-2.93-14.3-4.14-5.76-1.21-12.4-3.11-14.7-4.21-2.35-1.1-5.59-3.51-7.21-5.36-1.91-2.18-3.19-4.98-3.64-7.99-0.412-2.74-0.224-6.22 0.459-8.5 0.635-2.12 2.29-5.2 3.67-6.84 1.43-1.7 4.98-3.92 8.22-5.15 5.13-1.94 7.12-2.11 19.7-1.69 7.7 0.256 14.8 0.808 15.8 1.23 1.22 0.517 1.71 1.61 1.5 3.39-0.277 2.39-0.62 2.58-3.8 2.12-1.92-0.275-9.35-0.5-16.5-0.5-10.5 0-13.6 0.334-16.2 1.77-1.78 0.972-3.92 3.09-4.75 4.7-0.834 1.61-1.52 4.33-1.52 6.03s0.663 4.38 1.47 5.95c0.829 1.6 3.34 3.73 5.75 4.88 2.35 1.12 8.78 2.96 14.3 4.11 5.5 1.14 12.5 3.31 15.5 4.82 3.24 1.62 6.42 4.13 7.73 6.11 1.22 1.85 2.51 4.89 2.86 6.76s0.339 5.38-0.0259 7.81-1.65 5.92-2.86 7.74c-1.22 1.84-4.43 4.43-7.2 5.81-4.53 2.25-6.31 2.5-19 2.68-7.7 0.104-16.8-0.269-20.3-0.83zm69.9-0.582c-2.03-1.03-4.28-3.38-5.5-5.75-2-3.87-2.07-5.47-2.07-48v-44l3.25-0.313c3.25-0.313 3.25-0.313 3.25 12.8v13.1h13c13 0 13 0 13 3s0 3-13.1 3h-13.1l0.307 28.6c0.307 28.6 0.307 28.6 3.11 31 2.21 1.9 3.91 2.4 8 2.37 2.86-0.0239 7.22-0.434 9.69-0.911 3.17-0.611 4.71-0.524 5.23 0.294 0.406 0.638 0.745 1.89 0.754 2.79 0.0103 1.1-1.43 2-4.43 2.75-2.44 0.615-7.51 1.12-11.2 1.12-4.5-0.001-7.97-0.593-10.2-1.75zm53.1 0.0829c-3.32-1.01-7.09-3.23-10.1-5.94-2.8-2.52-5.68-6.34-6.88-9.14-1.14-2.65-2.59-8.71-3.22-13.5-0.847-6.37-0.863-10.5-0.0608-15.7 0.6-3.87 2.01-9.5 3.14-12.5 1.46-3.9 3.51-6.79 7.09-10 3.2-2.88 6.9-5.08 10.1-6.04 2.82-0.838 8.93-1.51 13.7-1.51 4.93 0 10.9 0.673 13.9 1.56 3.82 1.14 6.73 2.99 10.6 6.75 4.37 4.27 5.71 6.43 7.53 12.2 1.7 5.37 2.21 9.44 2.21 17.5 0 8.04-0.512 12.1-2.19 17.3-1.49 4.67-3.44 8.21-6.14 11.1-2.17 2.36-6.3 5.32-9.18 6.59-4.09 1.8-7.41 2.36-15.2 2.59-7.06 0.201-11.6-0.191-15.3-1.33zm28.3-7.05c2.2-1.15 4.96-3.14 6.13-4.44 1.17-1.29 2.81-3.7 3.64-5.35 0.832-1.65 2.06-6.59 2.72-11 0.665-4.39 0.916-10.6 0.558-13.7-0.358-3.16-1.33-8.03-2.16-10.8-0.837-2.82-3.07-6.81-5.02-8.96-2.25-2.5-5.29-4.47-8.5-5.54-2.87-0.952-8.05-1.64-12.2-1.62-3.96 0.0222-9.22 0.759-11.7 1.64-2.47 0.878-5.77 2.82-7.34 4.31s-3.7 4.36-4.74 6.38-2.4 6.96-3.02 11c-0.631 4.07-0.84 10.2-0.471 13.8 0.366 3.58 1.14 8.42 1.73 10.8 0.606 2.41 2.77 6.18 5.03 8.74 2.72 3.1 5.42 4.97 8.63 5.99 3.11 0.995 7.68 1.39 13.7 1.19 6.75-0.226 10-0.824 13-2.39zm119 7.7c-2.08-0.529-5.06-1.63-6.63-2.43-1.57-0.81-4.27-2.67-6.02-4.14-1.74-1.47-4.26-4.82-5.6-7.46s-2.95-8.09-3.57-12.1c-0.629-4.03-0.9-11.1-0.601-15.8 0.322-5.04 1.44-10.9 2.75-14.5 1.53-4.16 3.68-7.44 7.02-10.7 3.36-3.28 6.39-5.16 10.1-6.25 3.01-0.893 8.99-1.56 14-1.56 6.32 0 10.3 0.558 14.1 1.99 3.21 1.2 6.98 3.68 9.49 6.25 2.29 2.34 5.11 6.39 6.26 9s2.53 8.6 3.07 13.3c0.536 4.71 0.714 8.99 0.397 9.51-0.337 0.545-13 0.934-30.5 0.934h-29.9v3.32c0 1.83 0.694 5.66 1.54 8.51 0.849 2.86 2.94 6.79 4.66 8.74 1.71 1.95 4.96 4.5 7.21 5.66 3.21 1.66 6.46 2.21 15.1 2.56 6.05 0.243 14.3-0.0761 18.4-0.709 4.08-0.633 7.74-0.798 8.14-0.366 0.397 0.432 1.01 1.74 1.36 2.92 0.545 1.81 0.144 2.22-2.64 2.73-1.8 0.331-10.3 0.821-18.8 1.09-8.52 0.268-17.2 0.0538-19.3-0.475zm37.7-43.2c-1.5-8.98-2.86-13.1-5.57-16.8-1.98-2.74-4.81-4.95-8.49-6.63-4.32-1.98-7.12-2.52-12.9-2.52-6.05 0-8.46 0.503-13 2.71-3.66 1.79-6.41 4.03-8.12 6.61-1.42 2.14-3.19 6.49-3.93 9.65-0.745 3.16-1.36 6.77-1.37 8-0.0156 2.25-0.0156 2.25 27 2.25h27zm21.8 43.1c-6.02-0.975-6.29-1.14-6-3.68 0.281-2.43 0.645-2.63 4.31-2.4 2.2 0.141 10.5 0.366 18.5 0.5 12.6 0.211 15-0.008 18.4-1.68 2.13-1.06 4.71-3.31 5.75-5 1.04-1.71 1.88-4.94 1.88-7.25 0.003-2.99-0.701-5.01-2.48-7.13-1.37-1.63-3.96-3.65-5.75-4.49-1.79-0.841-7.88-2.49-13.5-3.67-5.64-1.18-11.7-2.75-13.5-3.5-1.78-0.745-4.53-2.37-6.12-3.62-1.58-1.24-3.71-4.1-4.73-6.34s-1.85-5.65-1.85-7.58c0-1.92 0.834-5.34 1.85-7.58s3.06-5.03 4.53-6.19c1.48-1.16 4.97-2.87 7.76-3.8 4.09-1.36 7.72-1.6 18.7-1.24 8.1 0.264 14.6 0.947 15.9 1.68 1.74 0.942 2.14 1.77 1.63 3.43-0.37 1.2-0.776 2.31-0.902 2.46-0.126 0.149-2.59-0.236-5.48-0.855s-10.3-0.963-16.4-0.765c-9.38 0.303-11.7 0.712-14.7 2.58-1.97 1.22-4.11 3.38-4.75 4.79-0.644 1.41-1.17 3.88-1.17 5.48s0.527 4.06 1.17 5.48c0.644 1.41 2.61 3.46 4.38 4.55 1.76 1.09 8.32 3.11 14.6 4.48 6.25 1.37 12.7 3.02 14.4 3.65 1.65 0.636 4.52 2.27 6.37 3.64 1.85 1.36 4.27 4.52 5.37 7.01 1.55 3.51 1.88 5.85 1.47 10.4-0.39 4.3-1.26 6.82-3.26 9.45-1.5 1.97-4.81 4.52-7.34 5.67-3.86 1.75-6.87 2.12-18.6 2.31-7.7 0.122-16.8-0.238-20.3-0.799zm147 0.308c-1.38-0.46-3.85-1.54-5.5-2.4-1.65-0.859-4.18-2.84-5.63-4.4s-3.47-4.41-4.5-6.34c-1.67-3.13-1.9-6.48-2.18-31.8l-0.32-28.3 3.32 0.319 3.32 0.319 0.5 27.5c0.419 23.1 0.767 28 2.15 30.5 0.91 1.65 2.75 4.02 4.09 5.27s3.97 2.71 5.84 3.25c1.87 0.537 7.46 0.973 12.4 0.969 4.95-0.004 12-0.294 15.8-0.645l6.75-0.638v-33.4-33.4l3.25 0.313 3.25 0.313 0.262 35.6c0.262 35.6 0.262 35.6-2 36.3-1.24 0.364-10.4 0.863-20.3 1.11-9.9 0.244-19.1 0.0683-20.5-0.391zm62-0.308c-3.55-0.508-6.65-1.11-6.87-1.33-0.224-0.224-0.109-1.6 0.255-3.05 0.658-2.62 0.71-2.63 6.87-1.8 3.41 0.464 11.6 0.843 18.2 0.843 10.4 0 12.6-0.299 16.5-2.22 2.48-1.22 5.1-3.19 5.83-4.37 0.733-1.18 1.33-4.07 1.33-6.42s-0.7-5.62-1.56-7.28c-0.903-1.75-3.36-3.88-5.84-5.08-2.36-1.14-8.78-3-14.3-4.12-5.49-1.12-12.4-3.19-15.2-4.6-3.81-1.86-5.91-3.7-7.65-6.73-1.32-2.3-2.7-5.6-3.06-7.34-0.363-1.74-0.166-5 0.437-7.24 0.637-2.37 2.62-5.55 4.74-7.61 2.32-2.25 5.65-4.12 9.18-5.15 4.35-1.27 8.47-1.5 19.3-1.11 9.17 0.33 14.3 0.929 15.3 1.79 0.861 0.715 1.43 2.24 1.27 3.39-0.26 1.82-0.812 2.02-4.3 1.59-2.2-0.275-9.62-0.5-16.5-0.5-9.15 0-13.3 0.402-15.4 1.5-1.6 0.825-3.85 2.77-5 4.32-1.36 1.84-2.09 4.33-2.09 7.15 0 2.92 0.65 5.04 2 6.53 1.1 1.22 3.58 3.01 5.5 3.98s8.22 2.77 14 3.99 12.1 2.88 14 3.68c1.92 0.802 4.79 2.67 6.37 4.15s3.49 4.14 4.25 5.91c0.757 1.77 1.38 5.5 1.38 8.28 0 2.79-0.614 6.53-1.36 8.33-0.75 1.8-2.8 4.47-4.55 5.94s-5.49 3.36-8.32 4.2c-3.45 1.03-8.92 1.48-16.7 1.4-6.36-0.0679-14.5-0.539-18-1.05zm-737-1c-0.4-1-0.7-21.1-0.7-45.5v-44.4l-17 0.296c-17 0.296-17 0.296-17-2.95l0.0013-3.25h37.5c37.5 0 37.5 0 37.5 3s0 3-17 3h-17v45c0 45 0 45-2.83 45-1.56 0-3.13-0.3-3.5-0.667zm54 0.0459c-0.392-0.392-0.713-16.6-0.713-36 0-35.3 0-35.3 2.98-35.3 2.26 0 3.11 0.542 3.53 2.25 0.302 1.24 0.423 17.3 0.269 35.8-0.279 33.5-0.279 33.5-2.82 33.8-1.4 0.163-2.86-0.0247-3.25-0.417zm330-1c-0.278-0.724-0.387-23.4-0.244-50.3 0.26-49 0.26-49 3.26-49s3 0 3.5 32.2l0.5 32.2 19.2-17.9c18.7-17.5 19.3-17.9 23.5-17.9l4.27 0.0202-6 5.69c-20.5 19.4-23.6 22.5-23.3 23.3 0.168 0.476 8.18 9.93 17.8 21s17.6 20.6 17.8 21c0.183 0.498-1.41 0.905-3.53 0.905-3.78 0-4.27-0.459-20.8-19.4l-16.9-19.4-6.02 5.69-6.02 5.69-0.5 13.5c-0.5 13.5-0.5 13.5-3.26 13.8-1.61 0.185-2.97-0.231-3.26-1zm208 0.516c-0.367-0.367-0.667-23.1-0.667-50.5 0-49.8 0-49.8 2.99-49.8s2.99 0 3.25 32.8l0.263 32.8 19.5-18.3c19.1-18 19.6-18.3 23.9-18.3 4.38-0.0185 4.38-0.0185-6.5 10.3-5.99 5.66-12.8 12.1-15.2 14.2l-4.27 3.96 18.5 21.3c10.2 11.7 18.5 21.5 18.5 21.8 0 0.253-1.74 0.46-3.87 0.46-3.78 0-4.29-0.472-20.5-19-9.17-10.4-17-19-17.4-19-0.396 0-3.53 2.6-6.95 5.78l-6.23 5.78v13.2c0 13.2-0.007 13.2-2.33 13.2-1.28 0-2.63-0.3-3-0.667zm-539-90.4c-0.864-0.864-1.57-2.82-1.57-4.35s0.823-3.52 1.83-4.43 2.72-1.65 3.8-1.65 2.51 0.54 3.17 1.2 1.2 2.82 1.2 4.8-0.54 4.14-1.2 4.8-2.2 1.2-3.43 1.2-2.94-0.707-3.8-1.57z';
    let text = innerGroup.append('path')
      .attr('id', `tilastokeskus-logo-text-${this.id}`)
      .attr('class', `tilastokeskus-logo-text-${this.id}`)
      .attr('fill', values['tilastokeskusLogoColor'] || '#FFF')
      .attr('d', d);
  }

  public drawTilastokeskusWWW(selection, values) {
    let line1 = selection.append('text')
      .attr('x', 300)
      .attr('y', 400)
      .attr('fill', '#828282')
      .attr('font-size', 32)
      .attr('text-anchor', 'middle')
      .attr('font-weight', 'lighter')
      .attr('font-family', 'Open Sans')
      .text('www.stat.fi');
    let line2 = selection.append('text')
      .attr('x', 300)
      .attr('y', 440)
      .attr('fill', '#828282')
      .attr('font-size', 32)
      .attr('text-anchor', 'middle')
      .attr('font-weight', 'lighter')
      .attr('font-family', 'Open Sans')
      .text('@tilastokeskus');
    let line3 = selection.append('text')
      .attr('x', 300)
      .attr('y', 480)
      .attr('fill', '#828282')
      .attr('font-size', 32)
      .attr('text-anchor', 'middle')
      .attr('font-weight', 'lighter')
      .attr('font-family', 'Open Sans')
      .text('@statsfinland');
  }

  public drawTitleTextSlide1(selection, values) {
    let singleReturn = /\r\n|\n|\f/g;
    let lines = values['titleTextSlide1'].split(singleReturn);
    let rowNumber = lines.length;
    let lineHeight = values['titleTextSlide1FontSize'] * values['titleTextSlide1LineHeight'];
    let height = rowNumber * lineHeight;
    // let y = values['height'] / 2 - height / 2; // Deze is geschikt voor uitlijnen in het midden
    let y = values['titleTextSlide1Y'];
    let group = selection.append('g')
      .attr('id', `slide1-title-text-${this.id}`);
    let text = group.append('text')
      .attr('x', values['titleTextSlide1X'])
      .attr('y', y)
      .attr('dominant-baseline', 'hanging')
      .attr('fill', values['titleTextSlide1FontColor'])
      .attr('font-size', values['titleTextSlide1FontSize'])
      .attr('font-weight', values['titleTextSlide1FontWeight'])
      .attr('font-family', 'Open Sans')
      .attr('text-anchor', 'start');

    _.map(lines, (line, index) => {
      text.append('tspan')
        .attr('x', values['titleTextSlide1X'])
        .attr('y', y + index * lineHeight)
        .text(line);
    });
    return group
  }

  public drawTextSlide1(selection, values) {
    let singleReturn = /\r\n|\n|\f/g;
    let lines = values['textSlide1'].split(singleReturn);
    let rowNumber = lines.length;
    let lineHeight = values['textSlide1FontSize'] * values['textSlide1LineHeight'];
    let height = rowNumber * lineHeight;
    // let y = values['height'] / 2 - height / 2; // Deze is geschikt voor uitlijnen in het midden
    let y = values['textSlide1Y'];
    let group = selection.append('g')
      .attr('id', `slide1-text-${this.id}`);
    let text = group.append('text')
      .attr('x', values['textX'])
      .attr('y', y)
      .attr('dominant-baseline', 'hanging')
      .attr('fill', values['textSlide1FontColor'])
      .attr('font-size', values['textSlide1FontSize'])
      .attr('font-weight', values['textSlide1FontWeight'])
      .attr('font-family', 'Open Sans')
      .attr('text-anchor', 'start');

    _.map(lines, (line, index) => {
      text.append('tspan')
        .attr('x', values['textSlide1X'])
        .attr('y', y + index * lineHeight)
        .text(line);
    });
    return group;
  }

  public drawTitleSlide2(selection, values) {
    let text = selection.append('text')
      .attr('x', values['titleTextSlide2X'])
      .attr('y', values['titleTextSlide2Y'])
      .attr('fill', values['titleTextSlide2FontColor'])
      .attr('font-size', values['titleTextSlide2FontSize'])
      .attr('font-weight', values['titleTextSlide2FontWeight'])
      .attr('font-family', 'Open Sans')
      .text(values['titleTextSlide2']);
  }

  public drawSubTitleSlide2(selection, values) {
    let line1 = selection.append('text')
      .attr('x', values['subtitleTextSlide2X'])
      .attr('y', values['subtitleTextSlide2Line1Y'])
      .attr('fill', values['subtitleTextSlide2FontColor'])
      .attr('font-size', values['subtitleTextSlide2FontSize'])
      .attr('font-weight', values['subtitleTextSlide2FontWeight'])
      .attr('font-family', 'Open Sans')
      .text(values['subtitleTextSlide2Line1']);
    let line2 = selection.append('text')
      .attr('x', values['subtitleTextSlide2X'])
      .attr('y', values['subtitleTextSlide2Line2Y'])
      .attr('fill', values['subtitleTextSlide2FontColor'])
      .attr('font-size', values['subtitleTextSlide2FontSize'])
      .attr('font-weight', values['subtitleTextSlide2FontWeight'])
      .attr('font-family', 'Open Sans')
      .text(values['subtitleTextSlide2Line2']);
  }

  public drawLineHorSteps(selection, values, data) {
    this.drawSteps(selection, values, data);
    this.drawUnitTextSteps(selection, values);
    this.drawXAxisSteps(selection, values, data);
    this.drawXAxisLabels(selection, values);
    this.drawNLines(selection, values, data);
  }

  public animateSlide1(timeline, values?) {
    timeline.from(`#slide1-logo-group-${this.id}`, 1, { opacity: 0 }, 'startAnimationSlide01');
    timeline.from(`#slide1-title-text-${this.id}`, 1, { opacity: 0 }, 'startAnimationSlide01');
    timeline.from(`#slide1-text-${this.id}`, 1, { opacity: 0 }, 'startAnimationSlide01');

    timeline.from(`#slide1-icon-${this.id}`, 0.5, { opacity: 0, scale: 0 , transformOrigin: '50% 50%'}, 'startScaleIconSlide01');
  }

  public animateTilastokeskusScaleBarsWithSomeDelay(timeline, values?, id?) {
    let idValue = (id ? `${id}-${this.id}` : `${this.id}`);
    timeline.staggerFrom(`.tilastokeskus-logo-top-${idValue}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 0.1, 'startAppearTilastokeskusBars');
    timeline.staggerFrom(`.tilastokeskus-logo-bottom-${idValue}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 0.1, 'startAppearTilastokeskusBars');
  }

}




// WEBPACK FOOTER //
// ./src/app/animations/demo-tilastokeskus-triptych-line-hor-steps/demo-tilastokeskus-triptych-line-hor-steps.component.ts